type Permission = {
  action?: string
  resource?: string
}

export default defineNuxtRouteMiddleware(async (to) => {
  const { $apis } = useNuxtApp()
  const { data } = await $apis.permissions.listIndividualPermissions()
  const { action, resource }: Permission = to.meta?.permission ?? {}

  localStorage.setItem('perm', JSON.stringify(data))

  if (resource && action && !data[resource][action]) {
    return navigateTo({
      name: 'errors-ErrorPermission',
      query: {
        message: `The page you are trying to access for ${resource} has restricted access. Please contact your administrator for permission.`,
        from: 'middleware',
      },
    })
  }
})
